module.exports = __webpack_public_path__ + "img/bbh-sir-john-hegarty.7e46cfa2.jpg";